// TODO: Import React module
import React from 'react';

// TODO: Import MUI module
import Box from '@mui/material/Box';

// TODO: Import MUI icon

// TODO: Import context
import { Context } from '../Common/Context';
import { Text } from '../Common/Text';

// TODO: Import custom component
import BoxSubPage from '../Common/BoxSubPage';
import RightSideNavigation from './BlessedBotanicals/RightSideNavigation';
import Home from './BlessedBotanicals/Home';
import EBook from './BlessedBotanicals/EBook';
import Garden from './BlessedBotanicals/Garden';
import Knowledge from './BlessedBotanicals/Knowledge';
import Activities from './BlessedBotanicals/Activities';
import Timelapse from './BlessedBotanicals/Timelapse';

const BlessedBotanicals = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component BlessedBotanicals Rendered');

    // TODO: Define useContext
    const context = React.useContext(Context);

    // TODO: Define variable

    // TODO: Define event

    // TODO: Return component
    return (
        <Box id="BlessedBotanicals">
            <BoxSubPage
                image={'https://www.pohtyh.edu.hk/Files/CampusDevelopment/Slide_BB.jpg'}
                title={Text.Top.Menu['CampusDevelopment'].Title[context.language]}
                subtitles={Text.Top.Menu['CampusDevelopment'].Subtitles}
            >
                <Box sx={{ display: 'flex' }}>
                    <Box component="main" sx={{ width: '80%' }}>
                        <Home />
                        <EBook />
                        <Garden />
                        <Knowledge />
                        <Activities />
                        <Timelapse />
                    </Box>
                    <Box sx={{ position: 'fixed', right: 0, bottom: 0 }}>
                        <RightSideNavigation />
                    </Box>
                </Box>
            </BoxSubPage>
        </Box>
    );
};
export default BlessedBotanicals;